import request from '../utils/request.js'

export async function getUserAuth (params, callback) {
  return request.service({
    url: '/api_company/auth/login',
    method: 'post',
    data: params
  }).then(callback)
}//登录获取token
